var C = Object.defineProperty;
var D = (d, e, s) => e in d ? C(d, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : d[e] = s;
var o = (d, e, s) => D(d, typeof e != "symbol" ? e + "" : e, s);
import U from "ws";
function E(d) {
  const e = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (s) => {
    const n = Math.random() * 16 | 0;
    return (s === "x" ? n : n & 3 | 8).toString(16);
  });
  return d !== void 0 ? `${e}:${d}` : e;
}
const A = globalThis.WebSocket ?? U;
class O {
  constructor(e) {
    o(this, "socket");
    o(this, "config");
    o(this, "currentUserId");
    o(this, "responsesPromises", {});
    o(this, "deviceId");
    o(this, "onMessageListener");
    o(this, "onMessageStatusListener");
    o(this, "onMessageEditListener");
    o(this, "onMessageDeleteListener");
    o(this, "onMessageReactionsListener");
    o(this, "onUserActivityListener");
    o(this, "onUserTypingListener");
    o(this, "onConversationCreateListener");
    o(this, "onConversationUpdateListener");
    o(this, "onConversationDeleteListener");
    o(this, "onConnectEvent");
    o(this, "onMessageEvent");
    o(this, "onSystemMessageEvent");
    o(this, "onDisconnectEvent");
    this.config = e;
  }
  async connect(e, s) {
    return e && (this.config.endpoint.ws = e), s && (this.config.endpoint.http = s), new Promise((n, i) => {
      this.socket = new A(this.config.endpoint.ws), this.socket.onopen = () => {
        var r;
        console.log("[socket.open]"), (r = this.onConnectEvent) == null || r.call(this), n();
      }, this.socket.onmessage = (r) => {
        var g, _, p, v, f, k, b, q, R, x, w, S, L, P;
        const t = JSON.parse(r.data);
        if (console.log("[socket.message]", t), t.typing) {
          (g = this.onUserTypingListener) == null || g.call(this, t.typing);
          return;
        }
        if (t.system_message || (_ = t.message) != null && _.system_message) {
          const a = t.system_message ?? ((p = t.message) == null ? void 0 : p.system_message), { conversation_created: l, conversation_updated: m, conversation_kicked: u } = (a == null ? void 0 : a.x) ?? {};
          if (l) {
            (v = this.onConversationCreateListener) == null || v.call(this, l);
            return;
          }
          if (m) {
            (f = this.onConversationUpdateListener) == null || f.call(this, m);
            return;
          }
          if (u) {
            (k = this.onConversationDeleteListener) == null || k.call(this, u);
            return;
          }
          (b = this.onSystemMessageEvent) == null || b.call(this, a);
          return;
        }
        if (t.last_activity) {
          (q = this.onUserActivityListener) == null || q.call(this, t.last_activity);
          return;
        }
        if (t.message_read) {
          (R = this.onMessageStatusListener) == null || R.call(this, t.message_read);
          return;
        }
        if (t.message_edit) {
          (x = this.onMessageEditListener) == null || x.call(this, t.message_edit);
          return;
        }
        if (t.message_delete) {
          (w = this.onMessageDeleteListener) == null || w.call(this, t.message_delete);
          return;
        }
        if (t.message_reactions_update) {
          (S = this.onMessageReactionsListener) == null || S.call(this, t.message_reactions_update);
          return;
        }
        if (t.message) {
          if (t.message.error) {
            const a = t.message.id ?? Object.keys(this.responsesPromises).filter((l) => l.length == 37).slice(-1)[0];
            this.responsesPromises[a].reject(t.message.error), delete this.responsesPromises[a];
            return;
          }
          (L = this.onMessageListener) == null || L.call(this, t.message), t.message.from.toString() !== this.currentUserId && ((P = this.onMessageEvent) == null || P.call(this, t.message));
          return;
        }
        if (t.ask) {
          const a = t.ask.mid;
          this.responsesPromises[a].resolve(t.ask), delete this.responsesPromises[a];
          return;
        }
        const c = t.response;
        if (c) {
          const a = c.id;
          if (!a) {
            console.error(c.error);
            return;
          }
          const { resolve: l, reject: m, resObjKey: u } = this.responsesPromises[a];
          if (c.error)
            c.error.status === 403 ? this.responsesPromises[a].reject(c.error) : m(c.error);
          else if (Array.isArray(u)) {
            const I = u.reduce((h, y) => (c[y] !== void 0 && (h[y] = c[y]), h), {});
            u.every((h) => h in I) ? l(I) : m({ message: "Server error." });
          } else u ? c[u] ? l(c[u]) : m({ message: "Server error." }) : l(c);
          delete this.responsesPromises[a];
        }
      }, this.socket.onerror = (r) => {
        console.log("[socket.error]", r), i(r);
      }, this.socket.onclose = () => {
        var r;
        console.log("[socket.close]"), (r = this.onDisconnectEvent) == null || r.call(this), this.config.disableAutoReconnect || this.reconnect();
      };
    });
  }
  reconnect() {
    const e = () => {
      navigator.onLine && document.visibilityState === "visible" && (this.connect(), window.removeEventListener("online", e), document.removeEventListener("visibilitychange", e));
    };
    navigator.onLine && document.visibilityState === "visible" ? this.connect() : (window.addEventListener("online", e), document.addEventListener("visibilitychange", e));
  }
  async disconnect() {
    var e;
    return (e = this.socket) == null ? void 0 : e.close();
  }
  async sendRequest(e, s = {}, n = "success") {
    const i = {
      request: {
        [e]: s,
        id: E(e)
      }
    };
    return this.sendPromise(i, n);
  }
  async sendPromise(e, s) {
    return new Promise((n, i) => {
      if (!this.socket) {
        i("Socket is not connected.");
        return;
      }
      this.socket.send(JSON.stringify(e)), console.log("[socket.send]", e), this.responsesPromises[e.request.id] = { resolve: n, reject: i, resObjKey: s };
    });
  }
  async sendHttpPromise(e, s, n) {
    console.log("[http.request]", { request: n });
    const i = { "Content-Type": "application/json" }, r = localStorage.getItem("sessionId");
    r && (i.Authorization = `Bearer ${r}`);
    const t = {
      method: e,
      credentials: "include",
      headers: i
    };
    n && (t.body = JSON.stringify(n));
    const c = await fetch(`${this.config.endpoint.http}/${s}`, t), g = await c.text();
    if (!c.ok)
      throw console.error("[http.error]", g), g || c.statusText;
    const _ = g ? JSON.parse(g) : {};
    return console.log("[http.response]", { response: _ }), _;
  }
  async connectSocket(e) {
    return this.sendRequest("connect", { token: e.token, device_id: e.deviceId ?? this.deviceId });
  }
  async socketLogin(e) {
    return this.sendRequest("user_login", { organization_id: this.config.organization_id, ...e.user, device_id: e.deviceId ?? this.deviceId, token: e.token }, ["user", "token"]);
  }
  async disconnectSocket() {
    return this.sendRequest("user_logout");
  }
  async userCreate(e) {
    return this.sendRequest("user_create", { organization_id: this.config.organization_id, login: e.login, email: e.email, password: e.password }, "user");
  }
  async userEdit(e) {
    return this.sendRequest("user_edit", e, "user");
  }
  async userLogin(e) {
    const { login: s, password: n } = e || {}, i = Date.now();
    parseInt(localStorage.getItem("sessionExpiredAt") || `${i}`, 10) - i <= 0 && localStorage.removeItem("sessionId");
    const t = { organization_id: this.config.organization_id, device_id: this.deviceId };
    return s && n && (t.login = s, t.password = n), await this.sendHttpPromise("POST", "login", t);
  }
  async userLogout() {
    return await this.sendHttpPromise("POST", "logout", null);
  }
  async userSendOTPToken(e) {
    const s = { organization_id: this.config.organization_id, device_id: this.deviceId, email: e.email };
    return this.sendRequest("user_send_otp", s);
  }
  async userResetPassword(e) {
    const s = { organization_id: this.config.organization_id, device_id: this.deviceId, email: e.email, token: e.token, new_password: e.new_password };
    return this.sendRequest("user_reset_password", s);
  }
  async userDelete() {
    return localStorage.removeItem("sessionId"), this.sendRequest("user_delete");
  }
  async userSearch(e) {
    const s = {
      keyword: e.keyword,
      ignore_ids: e.ignore_ids || [],
      ...e.limit && { limit: e.limit },
      ...e.updated_at && { updated_at: e.updated_at }
    };
    return this.sendRequest("user_search", s, "users");
  }
  async getUsersByIds(e) {
    return this.sendRequest("get_users_by_ids", { ids: e.ids }, "users");
  }
  async getParticipantsByCids(e) {
    return this.sendRequest("get_participants_by_cids", { cids: e.cids }, ["users", "conversations"]);
  }
  async createUploadUrlForFiles(e) {
    return this.sendRequest("create_files", e.files, "files");
  }
  async getDownloadUrlForFiles(e) {
    return this.sendRequest("get_file_urls", { file_ids: e.file_ids }, "file_urls");
  }
  async messageCreate(e) {
    return new Promise((s, n) => {
      var r;
      const i = {
        message: {
          id: e.mid,
          body: e.body,
          cid: e.cid,
          x: e.x,
          attachments: e.attachments,
          replied_message_id: e.replied_message_id,
          forwarded_message_id: e.forwarded_message_id
        }
      };
      this.responsesPromises[i.message.id] = { resolve: s, reject: n }, (r = this.socket) == null || r.send(JSON.stringify(i)), console.log("[socket.send]", i);
    });
  }
  async messageSystem(e) {
    return new Promise((s, n) => {
      var r;
      const i = {
        system_message: {
          id: e.mid,
          uids: e.uids,
          cid: e.cid,
          x: e.x
        }
      };
      this.responsesPromises[i.system_message.id] = { resolve: s, reject: n }, (r = this.socket) == null || r.send(JSON.stringify(i)), console.log("[socket.send]", i);
    });
  }
  async messageList(e) {
    const s = {
      cid: e.cid,
      ...e.ids && { ids: e.ids },
      ...e.limit && { limit: e.limit },
      ...e.updated_at && { updated_at: e.updated_at }
    };
    return this.sendRequest("message_list", s, "messages");
  }
  async messageSummary(e) {
    return this.sendRequest("message_summary", { cid: e.cid, filter: e.filter }, "message");
  }
  async messageTone(e) {
    return this.sendRequest("message_tone", { body: e.body, tone: e.tone }, "message");
  }
  async markConversationAsRead(e) {
    return this.sendRequest("message_read", { cid: e.cid, ids: e.mids });
  }
  async messageEdit(e) {
    return this.sendRequest("message_edit", { id: e.mid, body: e.body });
  }
  async messageDelete(e) {
    return this.sendRequest("message_delete", { cid: e.cid, ids: e.mids, type: e.type ?? "myself" });
  }
  async getUserActivity(e) {
    return this.sendRequest("user_last_activity", { ids: e }, "last_activity");
  }
  async subscribeToUserActivity(e) {
    return this.sendRequest("user_last_activity_subscribe", { id: e }, "last_activity");
  }
  async unsubscribeFromUserActivity() {
    return this.sendRequest("user_last_activity_unsubscribe");
  }
  async sendTypingStatus(e) {
    return new Promise((s, n) => {
      var r;
      const i = { typing: { cid: e.cid, status: e.status } };
      (r = this.socket) == null || r.send(JSON.stringify(i)), console.log("[socket.send]", i), s();
    });
  }
  async conversationCreate(e) {
    return this.sendRequest("conversation_create", e, "conversation");
  }
  async conversationUpdate(e) {
    var s, n;
    return this.sendRequest("conversation_update", {
      id: e.cid,
      name: e.name,
      description: e.description,
      participants: {
        add: (s = e.participants) == null ? void 0 : s.add,
        remove: (n = e.participants) == null ? void 0 : n.remove
      },
      image_object: e.image_object
    }, "conversation");
  }
  async conversationList(e) {
    var n;
    const s = {
      ...e.limit && { limit: e.limit },
      ...e.updated_at && { updated_at: { gt: e.updated_at.gt, lt: e.updated_at.lt } },
      ...((n = e.ids) == null ? void 0 : n.length) && { ids: e.ids }
    };
    return this.sendRequest("conversation_list", s, "conversations");
  }
  async conversationDelete(e) {
    return this.sendRequest("conversation_delete", { id: e.cid });
  }
  async conversationSearch(e) {
    return this.sendRequest(
      "conversation_search",
      { name: e.name, ...e.limit != null && { limit: e.limit } },
      "conversations"
    );
  }
  async conversationHandlerCreate(e) {
    return this.sendRequest("conversation_handler_create", { cid: e.cid, content: e.content });
  }
  async getConversationHandler(e) {
    return this.sendRequest("get_conversation_handler", { cid: e.cid }, "conversation_handler");
  }
  async conversationHandlerDelete(e) {
    return this.sendRequest("conversation_handler_delete", { cid: e.cid });
  }
  async pushSubscriptionCreate(e) {
    return this.sendRequest("push_subscription_create", {
      platform: "web",
      web_endpoint: e.web_endpoint,
      web_key_auth: e.web_key_auth,
      web_key_p256dh: e.web_key_p256dh,
      device_udid: this.deviceId
    }, "subscription");
  }
  async pushSubscriptionDelete() {
    return this.sendRequest("push_subscription_delete", { device_udid: this.deviceId });
  }
  async ping() {
    return this.sendRequest("ping", {}, "pong");
  }
  async setActivityStatus(e) {
    return this.sendRequest("activity_status", { isInactive: !!e }, "success");
  }
  async blockList() {
    return this.sendRequest("list_blocked_users", {}, "users");
  }
  async blockUsers(e) {
    return this.sendRequest("block_user", { ids: e }, "success");
  }
  async unblockUsers(e) {
    return this.sendRequest("unblock_user", { ids: e }, "success");
  }
  async reactionsUpdate(e, s, n) {
    return this.sendRequest("message_reactions_update", { mid: e, add: s, remove: n }, "success");
  }
  async reactionsList(e) {
    return this.sendRequest("message_reactions_list", { mid: e }, "reactions");
  }
}
export {
  O as SAMAClient
};
